import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';

export class XanoCollectionNameList extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollectionId: null,
    fieldDatatypes: [],
  };
  handleFormSubmit = () => {
    const { projectId, version } = this.props.match.params;
    const { uuid } = this.props.projectOnBoard.apiResponseData;
    const { history } = this.props
    if (uuid) {
      history.push(
        `/project-on-board/${version}/v/${projectId}/xano-collection-namelist/xano-tables/${uuid}`,
        {
          token: history.location.state.token,
          selectedCollectionId: this.state.selectedCollectionId,
        },
      );
    } else {
      console.error('UUID not found in the Redux store.');
    }
  };

  handleContinueButtonClick = () => {
    const { allColname } = this.props.location.state;
    const { selectedCollectionId } = this.state;
    let currentIndex = allColname.findIndex((item) => item.id === selectedCollectionId);
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < allColname.length) {
      const nextCollectionId = allColname[nextIndex].id;
      this.setState({ selectedCollectionId: nextCollectionId }, () => {
        this.handleFormSubmit();
      });
    }
  };
  render() {
    const { allColname } = this.props.location.state;
    const { uuid } = this.props.projectOnBoard.apiResponseData;
    const { history, match } = this.props;
    const { projectId } = match.params;

    if (!uuid) {
      history.push(`/collections/${projectId}/create`, {
        select: "XANO"
      });
      return null;
    }
    return (
      <CommonPageComponent>
        <ParentContentCard title={' List of Collections via Xano'} icon={'collection'}>
          <div className="d-flex">
            {allColname.map((item, index) => (
              <span className={`card card--user-profile ml-4 card--collection-source`} key={index}>
                <div className="card-body">
                  <div className="avatar__meta">
                    <h5 className="avatar__title js-user-name" title={item.name}>
                      {item.name}
                    </h5>
                  </div>
                </div>
              </span>
            ))}
          </div>
          <div className="text-right">
            {allColname.length > 0 && (
              <button
                className="btn btn-theme-submit mt-3 float-right"
                onClick={this.handleContinueButtonClick}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
              </button>
            )}
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoCollectionNameList);
